import * as Sentry from '@sentry/vue';
import { CaptureConsole, ExtraErrorData, ReportingObserver } from '@sentry/integrations';

import { env } from '../constants';

export default defineNuxtPlugin((nuxtApp) => {
  if (!env.SENTRY_DSN) return;

  const router = useRouter();

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: env.SENTRY_DSN,
    release: env.APP_VERSION,
    environment: env.SENTRY_ENVIRONMENT,
    hooks: ['mount', 'update', 'destroy'],
    trackComponents: true,
    logErrors: true,
    attachProps: true,
    normalizeDepth: 5,
    ignoreErrors: [
      'AbortError',
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'The mask was not set because videoWidth and videoHeight are not avaliable',
      /^Gone$/,
    ],

    replaysSessionSampleRate: 0,
    // The quota for this is very low, so collecting only 20% to have variety of errors with replay
    replaysOnErrorSampleRate: 0.2,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    tracesSampleRate: 0.1,

    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      new Sentry.Replay(),
      new CaptureConsole({ levels: ['warn', 'error'] }),
      new ExtraErrorData(),
      new ReportingObserver(),
    ],
  });

  Sentry.setTag('widget', true);
});
